import { ButtonBase } from "client/Components";
import styles from "./BackButton.module.less";
import { ReactElement } from "react";
import { useTitleBarNavigationStore } from "./titleBarNavigationStore";
import { Render } from "./TitleBarButton/Render";
import { WorkspaceHeaderStyle } from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";
import { useCallbackWithoutArguments } from "client/Hooks";

export type BackButtonProps = {
	headerStyle: WorkspaceHeaderStyle;
};

export const BackButton = (props: BackButtonProps): ReactElement | null => {
	const {
		headerStyle
	} = props;

	const backNavigationCallback: (() => void) | undefined = useTitleBarNavigationStore(
		x => x.backNavigationCallback
	);

	const clickHandler: (() => void) | undefined = useCallbackWithoutArguments(backNavigationCallback);

	return clickHandler
		? (
			<ButtonBase
				className={styles.root}
				onClick={clickHandler}
				trackingId="back-button"
			>
				<Render
					headerStyle={headerStyle}
					icon="chevron-left"
				/>
			</ButtonBase>
		) : null;
};
BackButton.displayName = "BackButton";